import React, { useEffect, useState } from 'react'
import { getTrainingVideos } from '../../../services/trainingService'
import './Training.scss'

function extractYoutubeId(url) {
  const match = url.match(/(?:youtu\.be\/|v=)([^&]+)/)
  return match ? match[1] : null
}

function VideoPlayerModal({ video, onClose }) {
  const ytId = extractYoutubeId(video.youtubeUrl)

  return (
    <div className="training__player-overlay" onClick={onClose}>
      <div className="training__player-modal" onClick={(e) => e.stopPropagation()}>
        <button className="training__player-close" onClick={onClose}>×</button>
        {ytId ? (
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${ytId}?autoplay=1`}
            title={video.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <p className="training__player-error">Não foi possível carregar este vídeo.</p>
        )}
      </div>
    </div>
  )
}

const Training = () => {
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(true)
  const [activeVideo, setActiveVideo] = useState(null)

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getTrainingVideos('freelancer')
        setVideos(data)
      } catch (err) {
        console.error('Erro ao carregar vídeos de treinamento:', err)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  const featuredVideo = videos[0]
  const restVideos = videos.slice(1)

  return (
    <div className="training">

      {/* HEADER */}
      <div className="training__header">
        <div className="training__header-text">
          <h2>Treinamentos</h2>
          <p>Aprenda habilidades essenciais para melhorar seu desempenho e conseguir mais trabalhos</p>
        </div>
      </div>

      {loading ? (
        <p className="training__empty">Carregando vídeos...</p>
      ) : videos.length === 0 ? (
        <p className="training__empty">Nenhum vídeo de treinamento publicado ainda.</p>
      ) : (
        <>
          {/* HERO / VÍDEO EM DESTAQUE */}
          {featuredVideo && (
            <div className="training__hero" onClick={() => setActiveVideo(featuredVideo)}>
              <div className="training__hero-video">
                {extractYoutubeId(featuredVideo.youtubeUrl) ? (
                  <img
                    src={`https://img.youtube.com/vi/${extractYoutubeId(featuredVideo.youtubeUrl)}/hqdefault.jpg`}
                    alt={featuredVideo.title}
                    className="training__hero-thumb"
                  />
                ) : null}
                <span className="training__hero-play">▶</span>
              </div>
              <div className="training__hero-content">
                <span className="training__tag training__tag--soft">Destaque</span>
                <h3>{featuredVideo.title}</h3>
                {featuredVideo.description && <p>{featuredVideo.description}</p>}
                <div className="training__hero-footer">
                  <button className="training__btn training__btn--primary" onClick={() => setActiveVideo(featuredVideo)}>
                    Assistir agora
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* GRID DE VÍDEOS */}
          {restVideos.length > 0 && (
            <div className="training__grid">
              {restVideos.map((video) => {
                const ytId = extractYoutubeId(video.youtubeUrl)
                return (
                  <div className="training__card" key={video.id} onClick={() => setActiveVideo(video)}>
                    <div className="training__thumb">
                      {ytId ? (
                        <img
                          src={`https://img.youtube.com/vi/${ytId}/mqdefault.jpg`}
                          alt={video.title}
                          className="training__thumb-img"
                        />
                      ) : null}
                      <span className="training__thumb-play">▶</span>
                    </div>

                    <div className="training__content">
                      <h3>{video.title}</h3>
                      {video.description && <p>{video.description}</p>}

                      <div className="training__footer">
                        <span className="training__footer-date">
                          {new Date(video.publishedAt).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' })}
                        </span>
                        <button className="training__btn training__btn--primary" onClick={(e) => { e.stopPropagation(); setActiveVideo(video) }}>
                          Assistir
                        </button>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </>
      )}

      {activeVideo && (
        <VideoPlayerModal video={activeVideo} onClose={() => setActiveVideo(null)} />
      )}
    </div>
  )
}

export default Training